import styled from 'styled-components';

export const LogoContainer = styled.div`
  height: 150px;
  margin-top: 32px;
  text-align: center;

  & img {
    width: 200px;
  }
`;

export const Instruction = styled.p`
  margin-bottom: 32px;
  text-align: center;
`;
